import React, { Component } from 'react';
import Container from 'react-bootstrap/Container'

import "./style.css";
import DeportesComponent from './component';

import reducer from "./reducer";
import { createStore, applyMiddleware, combineReducers } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from "redux-saga";
import { watchUsers } from "./saga";
import { Provider } from 'react-redux';
import { reducer as formReducer } from 'redux-form';

const sagaMiddleware = createSagaMiddleware();
const rootReducer = combineReducers({
    localReducer: reducer,
    form: formReducer,
});

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(watchUsers);

export default class DeportesPage extends Component {
    render() {
        return (
            <Provider store={store}>
                <Container className='deportes-main' >
                    <DeportesComponent urlParams = {this.props.match.params}/>
                </Container>
            </Provider>
        );
    }
}
